import { NavLink } from 'react-router-dom';

import { cn } from '@/lib/utils';
import { useShopPath } from '@/hooks/useShopPath';

/**
 * Top-level scope split for Settings — Store (per-shop) vs Account
 * (per-user / per-org). Sub-pages live under `/settings/store/*` and
 * `/settings/account/*` so the URL alone tells you what scope you're in;
 * no shop indicator copy or query param needed.
 *
 * In a chain the tabs render below the page header on every Settings
 * surface. In a single-shop org they're equally relevant — Account
 * settings still apply to the user, not the shop.
 */
export function SettingsTabs() {
	const { shopPath } = useShopPath();
	const tabs = [
		{ to: shopPath('/settings/store'), label: 'Store settings', sub: 'Local Storefront, billing, channels' },
		{ to: shopPath('/settings/account'), label: 'Account', sub: 'Team, notifications, security' }
	];

	return (
		<div className="border-b border-border/60">
			<div className="-mb-px flex gap-2">
				{tabs.map((tab) => (
					<NavLink
						key={tab.to}
						to={tab.to}
						className={({ isActive }) =>
							cn(
								'border-b-2 px-1 pb-3 pt-1 text-sm font-semibold transition-colors',
								isActive
									? 'border-foreground text-foreground'
									: 'border-transparent text-muted-foreground hover:text-foreground'
							)
						}
					>
						<span className="mr-4">{tab.label}</span>
					</NavLink>
				))}
			</div>
		</div>
	);
}
